<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-19 16:19:55
-->
<template>
  <div class="app-container">
    <div class="header">
      <div class="header-serach">
        <el-form :inline="true" :model="ruleform">
          <el-form-item label="">
            <el-input
              v-model="ruleform.entName"
              placeholder="搜索机构名称"
              @keyup.enter.native="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="ruleform.isOpen"
              placeholder="状态"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in isOpenList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="ruleform.organizationType"
              placeholder="机构等级"
              @change="getPoss"
              clearable
            >
              <el-option
                v-for="item in organizationTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-right">
        <el-button
          size="medium"
          v-if="roleText !== '机构' && roleText !== '服务机构'"
          @click="updateIsOpen(0)"
          type="danger"
          >禁用</el-button
        >
        <el-button
          size="medium"
          v-if="roleText !== '机构' && roleText !== '服务机构'"
          @click="updateIsOpen(1)"
          type="primary"
          >启用</el-button
        >
        <Debounce :time="5000" :isDebounce="3">
          <button
            type="button"
            class="el-button el-button--primary el-button--medium"
            @click="downloadOrgan"
          >
            导 出
          </button>
        </Debounce>
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        prop="entName"
        label="状态"
        width="100"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isOpen == 1" class="isOpen-tag"
            >已启用</el-tag
          >
          <el-tag type="info" v-else class="isOpen-tag">已禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="entName"
        label="机构名称"
        width="300"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="entName"
        label="机构等级"
        width="100"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.organizationType == 1 ? '普通机构' : '服务机构' }}
        </template>
      </el-table-column>
      <el-table-column
        label="联系人"
        prop="contact"
        width="250"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="contactTel"
        label="联系电话"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="serviceNameList"
        label="服务类型"
        align="center"
        width="190"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{
            scope.row.serviceNameList ? scope.row.serviceNameList.join(',') : ''
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="申请时间"
        align="center"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span
            style="margin-right: 10px; color: #1890ff; cursor: pointer"
            @click="
              edit(
                scope.row.creditCode,
                scope.row.entName,
                scope.row.organizationType
              )
            "
            >查看</span
          >
          <span
            class="table-text-btn"
            v-if="scope.row.organizationType == 1"
            @click="handleShowReturnDialog(scope.row)"
            >退回企业</span
          >
          <span
            class="table-text-btn"
            v-if="scope.row.organizationType == 2"
            @click="handleShowReturnDialog(scope.row)"
            >退回普通机构</span
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="returnText"
      :visible.sync="returnDialogVisible"
      width="30%"
      :before-close="handleClose"
      custom-class="rules-box"
    >
      <el-alert type="warning" show-icon :closable="false">
        <div slot="title">
          <div>退回规则：</div>
          <div v-html="returnContent[returnType].content"></div>
        </div>
      </el-alert>
      <div>
        <p>请再次确认以下信息，谨慎操作！</p>
        <div class="table-info">
          <table cellspacing="0" cellpadding="10">
            <tr v-for="(item, index) in returnInfo" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.value }}{{ item.unit }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="remark-box">
        <el-form
          ref="returnRuleForm"
          :rules="returnRules"
          :model="returnRuleForm"
          label-width="60px"
        >
          <el-form-item label="备注:" prop="remark">
            <el-input
              rows="3"
              type="textarea"
              v-model="returnRuleForm.remark"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleReturn('returnRuleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listByPage,
  updateIsOpen, // 启用禁用
  downloadEntIntermediary, // 导出
  instBackAuth, // 服务机构退回
  commonInstBackAuth, // 普通机构退回
  showGoodsAndOrderNum // 查询机构情况
} from '@api/yardIntermediary/institutionalManagement'
export default {
  data() {
    return {
      ttt: true,
      areaList: [],
      ruleform: {
        entName: '', // 机构名称
        isOpen: '', // 是否启用
        organizationType: '' // 机构类型
      },
      isOpenList: [
        { value: 0, label: '禁用' },
        { value: 1, label: '启用' }
      ], // 所有类别数据
      organizationTypeList: [
        { value: 1, label: '普通机构' },
        { value: 2, label: '服务机构' }
      ], // 所有类别数据
      proveStatusList: {
        0: '未认证',
        1: '待审核',
        2: '申请驳回',
        3: '审核通过'
      },
      statusList: [
        { value: '', label: '全部' },
        { value: 1, label: '待审核' },
        { value: 2, label: '申请驳回' },
        { value: 3, label: '审核通过' }
      ], // 所有类别数据
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0,
      roleText: '',
      selectedList: [],
      returnDialogVisible: false,
      returnText: '',
      returnType: 1, // 退回类型
      returnContent: {
        1: {
          title: '退回企业',
          content:
            '1、普通机构将退回至企业<br/>2、保留普通机构的申请信息<br/>3、退回后企业需要重新申请入驻普通机构'
        },
        2: {
          title: '退回普通机构',
          content:
            '1、服务券机构将退回至普通机构<br/>2、保留服务券机构的申请信息<br/>3、退回后企业需要重新申请入驻服务券机构'
        }
      },
      returnRuleForm: {
        remark: ''
      },
      returnRules: {
        remark: [
          { required: true, message: '请填写备注信息', trigger: 'blur' },
          { max: 200, message: '长度最多不超过 200 个字符', trigger: 'blur' }
        ]
      },
      returnInfo: [
        {
          name: '机构名称',
          value: '',
          unit: '',
          enName: ''
        },
        {
          name: '操作',
          value: '',
          unit: '',
          enName: ''
        },
        {
          name: '当前进行中订单',
          value: '',
          unit: '笔',
          enName: 'goodsOrderTotal'
        },
        {
          name: '发布商品数',
          value: '',
          unit: '个',
          enName: 'goodsTotal'
        },
        {
          name: '已上架普通商品数',
          value: '',
          unit: '个',
          enName: 'generalGoodsNum'
        }
      ]
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.listLiveData()
  },
  methods: {
    // 选择事件
    handleSelectionChange(val) {
      this.selectedList = val
    },
    // 启用禁用状态修改 0 禁用 1启用
    updateIsOpen(type) {
      if (this.selectedList.length == 0) {
        this.$message({
          message: '请先勾选机构',
          type: 'warning'
        })
        return false
      }
      let confirmTitle = type === 0 ? '是否禁用机构?' : '是否启用机构?'
      let msg =
        type === 0
          ? '禁用后，该机构的信息包括发布的产品不会在企业侧展示。但不影响功能使用'
          : '启用后，该机构的信息包括发布的产品展示在企业侧'
      this.$confirm(msg, confirmTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let idList = [] // 服务机构ids
          let commonIds = [] // 普通机构ids
          this.selectedList.forEach(item => {
            if (item.organizationType == 1) {
              commonIds.push(item.id)
            } else {
              idList.push(item.id)
            }
          })
          let params = {
            ids: idList.join(','),
            generalIds: commonIds.join(','),
            isOpen: type
          }
          updateIsOpen(params).then(res => {
            const result = res.data
            if (result.code == '0000') {
              this.$message({
                message: result.msg,
                type: 'success'
              })
              this.handleCurrentChange(1)
            } else {
              this.$message.error(res.data.msg)
            }
          })
        })
        .catch(() => {})
    },
    // 导出机构列表
    downloadOrgan() {
      let par = {
        entName: this.ruleform.entName,
        isOpen: this.ruleform.isOpen,
        organizationType: this.ruleform.organizationType
      }
      downloadEntIntermediary(par)
    },
    // 视频名称
    getSearch() {
      this.currentPage = 1
      this.listLiveData()
    },
    // 所有类别
    getPoss() {
      this.currentPage = 1
      this.listLiveData()
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.listLiveData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listLiveData()
    },
    edit(creditCode, entName, organizationType) {
      this.$router.push({
        name: 'intermediaryDetail',
        query: {
          creditCode: creditCode,
          entName: entName,
          organizationType: organizationType
        }
      })
    },
    // 列表
    listLiveData() {
      let par = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        entName: this.ruleform.entName,
        isOpen: this.ruleform.isOpen,
        organizationType: this.ruleform.organizationType
      }
      listByPage(par).then(res => {
        if (res.data.code == '0000') {
          const list = res.data.data
          this.tableData = list.results || []
          this.totalRecord = list.totalRecord || 0
        }
      })
    },
    handleShowReturnDialog(row) {
      this.returnType = row.organizationType
      this.returnText = this.returnContent[row.organizationType].title
      this.creditCode = row.creditCode
      this.returnDialogVisible = true
      this.returnInfo[0].value = row.entName
      this.returnInfo[1].value = this.returnText
      if (row.organizationType == 2 && this.returnInfo.length < 6) {
        this.returnInfo[5] = {
          name: '已上架服务券商品数',
          value: '',
          unit: '个',
          enName: 'serveGoodsNum'
        }
      } else if (row.organizationType == 1 && this.returnInfo.length == 6) {
        this.returnInfo.pop()
      }
      this.getGoodsAndOrderNum()
    },
    handleClose() {
      this.returnDialogVisible = false
      this.$refs.returnRuleForm.resetFields()
    },
    /**
     * @description:查询机构情况
     * @return {*}
     */
    getGoodsAndOrderNum() {
      const params = {
        creditCode: this.creditCode
      }
      showGoodsAndOrderNum({ params }).then(res => {
        const { code, msg, data } = res.data
        if (code == '0000') {
          this.returnInfo.slice(2).map(item => {
            item.value = data[item.enName]
          })
        } else {
          this.$message.error(msg)
        }
      })
    },
    /**
     * @description: 退回确认
     * @param {*} form
     * @return {*}
     */
    handleReturn(form) {
      const data = {
        creditCode: this.creditCode,
        organizationType: this.returnType,
        remark: this.returnRuleForm.remark
      }

      this.$refs[form].validate(valid => {
        if (valid) {
          let api = this.returnType == 2 ? instBackAuth : commonInstBackAuth
          api(data).then(res => {
            if (res.data.code == '0000') {
              this.handleClose()
              this.listLiveData()
              this.$message.success(res.data.msg)
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$commonColor: #1890ff;
.isOpen-tag {
  cursor: default;
}
.greenColor {
  background: chartreuse;
}
.redColor {
  background: rgb(151, 23, 23);
}
.greyColor {
  background: rgba(49, 48, 48, 0.3);
}
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  .header-serach {
    .el-input {
      width: 300px;
      // margin-right: 30px;
    }
  }
}
.actcolor {
  color: $commonColor;
}
.nocolor {
  color: rgba(0, 0, 0, 0.3);
}
.changeAppeal {
  cursor: pointer;
  color: $commonColor;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
.sharing-code {
  display: flex;
  span {
    line-height: 34px;
  }
  /deep/.el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  /deep/.el-button--medium {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.table-text-btn {
  margin-right: 10px;
  color: $commonColor;
  cursor: pointer;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #eee;
}
/deep/.el-alert {
  align-items: flex-start;
}
/deep/.el-alert__title {
  color: rgba(0, 0, 0, 0.85);
  div {
    line-height: 22px;
  }
}
.remark-box {
  margin-top: 20px;
}
.table-info {
  table {
    width: 100%;
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    tr td {
      text-align: center;
      width: 50%;
      border-right: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }
    tr td:first-child {
      background: rgba(244, 249, 252, 1);
    }
  }
}
.exhibition {
  // margin-top: 20px;
  margin-left: -25px;
  display: flex;
  #qrcode {
    width: 125px;
    height: 150px;
    margin: 20px auto;
  }
  .refreshs {
    margin: 20px auto;
    span {
      margin-left: 22px;
    }
    .refresh {
      margin-left: 50px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
.el-popover {
  min-width: 100px !important;
}
</style>
